const path = require("path")
const files = require.context("@/components", false, /\.vue$/)
console.log(files)
const modules = {}
files.keys().forEach((key) => {
  const name = path.basename(key, ".vue")
  modules[name] = files(key).default || files(key)
})
export default {
  components: modules,
}